import { ApiResponseType } from '@/api/type/commonTypes';
import { GetPartnerMeResponse } from '../type/types';
import { api } from '../axiosInstance';

export const getPartnerMe = async () => {
  const res = await api.get<ApiResponseType<GetPartnerMeResponse>>(
    '/api/web/partners/me'
  );
  return res.data;
};
